module.exports = __webpack_public_path__ + "static/media/HelveticaNeueCyr-Regular.fadb2adb.ttf";